import { createAsyncThunk } from '@reduxjs/toolkit';
import payrollServiceApiInstance from '../../../../../../config/payrollApiConfig';
import {
  CreateEsicBranchPayload,
  UpdateEsicBranchPayload,
} from './branchTypes';

// Create
export const createEsicBranch = createAsyncThunk(
  'esicBranch/create',
  async (data: CreateEsicBranchPayload, { rejectWithValue }) => {
    try {
      const response = await payrollServiceApiInstance.post('/esic-branch', data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to create ESIC branch');
    }
  }
);

// Fetch All
export const fetchEsicBranchList = createAsyncThunk(
  'esicBranch/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const response = await payrollServiceApiInstance.get('/esic-branch');
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch ESIC branches');
    }
  }
);

// Fetch By ID
export const fetchEsicBranchById = createAsyncThunk(
  'esicBranch/fetchById',
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await payrollServiceApiInstance.get(`/esic-branch/${id}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch ESIC branch');
    }
  }
);

// Update
export const updateEsicBranch = createAsyncThunk(
  'esicBranch/update',
  async ({ id, ...data }: UpdateEsicBranchPayload & { id: number }, { rejectWithValue }) => {
    try {
      const response = await payrollServiceApiInstance.put(`/esic-branch/${id}`, data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to update ESIC branch');
    }
  }
);

// Delete
export const deleteEsicBranch = createAsyncThunk(
  'esicBranch/delete',
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await payrollServiceApiInstance.delete(`/esic-branch/${id}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to delete ESIC branch');
    }
  }
);
